import axios from 'axios'

/**
 *
 * @param {}
 * @returns
 */
export const getProfileDetails = async () => {
  const response = await axios.get('/users/profile')
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const updateProfileDetails = async (payload) => {
  const response = await axios.put('users/update-profile', payload)
  return response
}

/**
 *
 * @param {image object} payload
 * @returns
 */

export const uploadProfilePicture = async (payload) => {
  const response = await axios.post(`users/profile-pic`, payload, {
    headers: { 'content-type': 'multipart/form-data' }
  })
  return response
}
